import { useMutation, useQueryClient } from '@tanstack/react-query';
import { abandonCart } from '@services/shoppingCartService';

export const useAbandonCart = (sessionId: string) => {
  const queryClient = useQueryClient();

  const mutation = useMutation<void, Error, string>({
    mutationFn: (cartId: string) => abandonCart(cartId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shoppingCart', sessionId] });
    },
  });

  return {
    abandonCart: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
};
